<button class="item" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
  <tc-dropdown-button>
    <tc-icon [iconClass]="'icofont icofont-notification'" [tcFontSize]="26"></tc-icon>
    <tc-badge *ngIf="user.notifications && user.notifications.length" [view]="'error'" [size]="'sm'">
      {{ user.notifications.length }}
    </tc-badge>
  </tc-dropdown-button>
</button>

<mat-menu #menu="matMenu">
  <div class="menu-header">
    <h4 class="h5 menu-title mt-0 mb-0">Notifications</h4>

    <a href="#" (click)="$event.preventDefault(); user.notifications = []"
       [tcColor]="['#ed5564', '#8E333C']">Clear All</a>
  </div>

  <ul class="list">
    <ng-container *ngIf="user.notifications && user.notifications.length">
      <li *ngFor="let item of user.notifications">
        <a href="#" (click)="select_claim($event,item.data)">
          <span class="icon {{ item.icon }}"></span>

          <div class="content">
              <span class="desc">{{ item.title | translate }}
                <small>({{format_date(item.data.created_at)}})</small></span>

            <span class="date">{{ item.detail }} </span>
          </div>
        </a>
      </li>
    </ng-container>

    <li *ngIf="!user.notifications || (user.notifications.length === 0)">
      <span class="empty-item">No notifications</span>
    </li>
  </ul>

  <div class="menu-footer" *ngIf="user.notifications && user.notifications.length">
    <a
      href="#"
      tc-button
      (click)="showAllNotifs()"
      [view]="'accent'"
      [block]="true"
      [afterIcon]="'icofont-tasks-alt'"
    >
      {{'HOME.btn.show_all'| translate}}
    </a>
  </div>
</mat-menu>

<button class="item" mat-icon-button [matMenuTriggerFor]="menu2" aria-label="Example icon-button with a menu">
  <tc-dropdown-button>
    <div class="d-flex align-items-center">
      <tc-avatar [src]="'/assets/content/user-icon.png'" class="mr-1"></tc-avatar>
      <i class="icofont-simple-down"></i>
    </div>
  </tc-dropdown-button>
</button>
<mat-menu #menu2="matMenu">
  <ul class="list">
    <li *ngIf="false">
      <a href="#" (click)="goTo($event, 'edit-account')" class="align-items-center">
        <span class="icon icofont-ui-home"></span>
        Edit account
      </a>
    </li>

    <li>
      <a href="#" (click)="goTo($event, 'user-profile')" class="align-items-center">
        <span class="icon icofont-ui-user"></span>
        Profile
      </a>
    </li>

    <li *ngIf="false">
      <a href="#" (click)="goTo($event, 'events-calendar')" class="align-items-center">
        <span class="icon icofont-ui-calendar"></span>
        Calendar
      </a>
    </li>

    <li>
      <a href="#" (click)="goTo($event, 'settings')" class="align-items-center">
        <span class="icon icofont-ui-settings"></span>
        {{'HOME.actions.settings'|translate}}
      </a>
    </li>

    <li>
      <a href="#" (click)="logout($event, '/', '/')" class="align-items-center">
        <span class="icon icofont-logout"></span>
        {{'HOME.actions.logout'|translate}}
      </a>
    </li>
  </ul>
</mat-menu>


<tc-dropdown class="item" [close]="closeDropdown2" *ngIf="false">
  <tc-dropdown-button>
    <tc-icon [iconClass]="'icofont icofont-notification'" [tcFontSize]="26"></tc-icon>
    <tc-badge *ngIf="user.notifications && user.notifications.length" [view]="'error'" [size]="'sm'">
      {{ user.notifications.length }}
    </tc-badge>
  </tc-dropdown-button>

  <tc-dropdown-content [align]="'right'" [animation]="'fadeInUp'" [offset]="[10, 0]">
    <div class="menu-header">
      <h4 class="h5 menu-title mt-0 mb-0">Notifications</h4>

      <a href="#" (click)="$event.preventDefault(); user.notifications = []" [tcColor]="['#ed5564', '#8E333C']">Clear
        All</a>
    </div>

    <ul class="list">
      <ng-container *ngIf="user.notifications && user.notifications.length">
        <li *ngFor="let item of user.notifications">
          <a href="#" (click)="select_claim($event,item.data)">
            <span class="icon {{ item.icon }}"></span>

            <div class="content">
              <span class="desc">{{ item.title | translate }}
                <small>({{format_date(item.data.created_at)}})</small></span>

              <span class="date">{{ item.detail }} </span>
            </div>
          </a>
        </li>
      </ng-container>

      <li *ngIf="!user.notifications || (user.notifications.length === 0)">
        <span class="empty-item">No notifications</span>
      </li>
    </ul>

    <div class="menu-footer" *ngIf="user.notifications && user.notifications.length">
      <a
        href="#"
        tc-button
        (click)="showAllNotifs()"
        [view]="'accent'"
        [block]="true"
        [afterIcon]="'icofont-tasks-alt'"
      >
        {{'HOME.btn.show_all'| translate}}
      </a>
    </div>
  </tc-dropdown-content>
</tc-dropdown>

<tc-dropdown class="item" [close]="closeDropdown" *ngIf="false">
  <tc-dropdown-button>
    <div class="d-flex align-items-center">
      <tc-avatar [src]="'/assets/content/user-icon.png'" class="mr-1"></tc-avatar>
      <i class="icofont-simple-down"></i>
    </div>
  </tc-dropdown-button>

  <tc-dropdown-content [align]="'right'" [animation]="'fadeInUp'" [offset]="[10, 0]" [width]="180">
    <ul class="list">
      <li *ngIf="false">
        <a href="#" (click)="goTo($event, 'edit-account')" class="align-items-center">
          <span class="icon icofont-ui-home"></span>
          Edit account
        </a>
      </li>

      <li>
        <a href="#" (click)="goTo($event, 'user-profile')" class="align-items-center">
          <span class="icon icofont-ui-user"></span>
          Profile
        </a>
      </li>

      <li *ngIf="false">
        <a href="#" (click)="goTo($event, 'events-calendar')" class="align-items-center">
          <span class="icon icofont-ui-calendar"></span>
          Calendar
        </a>
      </li>

      <li>
        <a href="#" (click)="goTo($event, 'settings')" class="align-items-center">
          <span class="icon icofont-ui-settings"></span>
          {{'HOME.actions.settings'|translate}}
        </a>
      </li>

      <li>
        <a href="#" (click)="logout($event, '/', '/')" class="align-items-center">
          <span class="icon icofont-logout"></span>
          {{'HOME.actions.logout'|translate}}
        </a>
      </li>
    </ul>
  </tc-dropdown-content>
</tc-dropdown>
